import {CampaignTrackerTypeName} from '../campaignTrackers/campaignTrackers.types';
import {
  Placement_UI,
  PlacementDSPCreative_UI,
  RemotePlacement_UI,
  RemotePlacementDSPCreative_UI,
  RemoteTTDCreative_UI,
} from './placements.types';
import _map from 'lodash/map';
import {DateTime} from 'luxon';
import {CLEnumKeys, CLEnumsMapper} from '../enums/enums.types';
import {DSPType} from '../dsp/dsp.types';

const DV360CreativeType = 'Standard';

export function toLocalPlacement_UI(
  remotePlacement: RemotePlacement_UI,
  trackersCountByPlacement: Record<number, Record<CampaignTrackerTypeName, number>>,
  campaignEnums: Record<string, CLEnumsMapper>,
  dsps: DSPType[],
): Placement_UI {
  return {
    ...remotePlacement,
    placementDspCreatives: _map(remotePlacement.placementDspCreatives, toLocalDSPCreative) || [],
    customDateTimeParams: remotePlacement.customDateTimeParams?.map(({type, value}) => ({
      type,
      value: DateTime.fromISO(value),
    })),
    trackers: (remotePlacement.trackers ?? []).map(({url, type}) => ({
      url,
      type,
      typeName: campaignEnums[CLEnumKeys.CampaignPage.PlacementEventTypes].byValue[type].name,
      label: 'main',
    })),
    trackersCount:
      trackersCountByPlacement[remotePlacement.id] ||
      ({} as Record<CampaignTrackerTypeName, number>),
    environmentName:
      campaignEnums[CLEnumKeys.CampaignPage.EnvironmentEnum].byValue[remotePlacement.environment]
        .name,
    dspName: dsps.find((dsp) => dsp.id === remotePlacement.dspId)?.dspType || '',
    dspUIName: dsps.find((dsp) => dsp.id === remotePlacement.dspId)?.uiName || '',
    customBooleanParams: remotePlacement.customBooleanParams || [],
  };
}

function toLocalDSPCreative(remote: RemotePlacementDSPCreative_UI): PlacementDSPCreative_UI {
  const ttdCreative = remote.dspCreative as RemoteTTDCreative_UI;
  const isDv360Creative = remote.dspCreative?.type === DV360CreativeType;

  return {
    ...remote,
    ...(remote.lastUpdateTimestamp && {
      lastUpdateTimestamp: DateTime.fromISO(remote.lastUpdateTimestamp),
    }),
    ...(remote.dspCreative && {
      dspCreative: {
        ...remote.dspCreative,
        isDv360: isDv360Creative,
        ...(!isDv360Creative && {
          ...ttdCreative,
          ...(ttdCreative.flightStartDate && {
            flightStartDate: DateTime.fromISO(ttdCreative.flightStartDate),
          }),
          ...(ttdCreative.flightEndDate && {
            flightEndDate: DateTime.fromISO(ttdCreative.flightEndDate),
          }),
        }),
      },
    }),
  };
}
